import { h } from 'vue'
import { registrarFuncao } from '@/components/base/workflow/aprovacoes/aprovacoesRegistry'
import { formatarDataBR } from '@/utils/useDataBR'
import FiltrosPurchaseOrder from './FiltrosPurchaseOrder.vue'
import DetalhesPurchaseOrderEnxuto from './DetalhesPurchaseOrderEnxuto.vue'
import DetalhesPurchaseOrderCompleto from './DetalhesPurchaseOrderCompleto.vue'

const formatarValor = (valor) => {
  if (valor == null) return '-'
  try {
    return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valor)
  } catch (e) {
    return valor?.toFixed(2) ?? '-'
  }
}

const slotRenderers = {
  resumoAprovacao: {
    props: ['row'],
    render () {
      const texto = this.row.resumoSolicitacao || '-'
      return h('span', {
        class: 'text-truncate d-inline-block',
        style: 'max-width: 200px',
        title: this.row.resumoSolicitacao || ''
      }, texto)
    }
  },
  acoes: {
    props: ['row', 'abrirModal'],
    render () {
      return h('div', { class: 'd-flex justify-content-end gap-1 acoes-wrapper' }, [
        h('button', {
          class: 'btn btn-sm btn-outline-info',
          onClick: () => this.abrirModal(this.row),
          title: 'Analisar'
        }, [
          h('i', { class: 'bi bi-search me-1' }),
          ' Analisar'
        ])
      ])
    }
  }
}

const definicao = {
  chave: 'PurchaseOrder',
  titulo: 'Aprovações de Purchase Orders',
  subtitulo: 'Análise e aprovação de purchase orders pendentes',
  apiEndpoint: '/WorkflowAprovacaoAnalise',
  entityKey: 'idWorkflowAprovacaoAnalise',
  campoHeader: 'idWorkflowAprovacaoAnalise',
  endpointLista: '/pendentes?processo=WORK_APR_PROCESSO2',
  endpointAprovar: '/aprovar',
  endpointReprovar: '/reprovar',
  listasTabelas: ['WorkflowAprovacaoAnalise', 'PurchaseOrder', 'PurchaseOrderProduto', 'PurchaseOrderCondicaoPg'],
  nomeEntidade: 'purchase order',
  nomeEntidadeTitle: 'Purchase Order',

  formatarValor,

  colunas: [
    { field: 'idWorkflowAprovacaoAnalise', label: '#', width: 80, sortable: true, formatter: (v, row) => '#' + row.idWorkflowAprovacaoAnalise, class: 'fw-medium text-body-emphasis' },
    { field: 'nomeProcesso', label: 'Processo', sortable: true, class: 'text-body-secondary' },
    { field: 'nomeStatus', label: 'Status', sortable: true },
    { field: 'nomeSolicitante', label: 'Solicitante', sortable: false },
    { field: 'tsEnviadoAprovacao', label: 'Enviado', align: 'center', sortable: true, formatter: (v) => v ? formatarDataBR(v) : '-' },
    { field: 'tsDefinicaoAnalise', label: 'Definição', align: 'center', sortable: true, formatter: (v) => v ? formatarDataBR(v) : '-' },
    { field: 'resumoSolicitacao', label: 'Resumo', sortable: false, slotName: 'resumoAprovacao' },
    { field: 'acoes', label: 'Ações', width: 120, align: 'right', slotName: 'acoes', resizable: false, sortable: false }
  ],

  slotRenderers,

  componenteFiltros: FiltrosPurchaseOrder,
  componenteDetalhesEnxuto: DetalhesPurchaseOrderEnxuto,
  componenteDetalhesCompleto: DetalhesPurchaseOrderCompleto,

  modalTitulo: 'Análise da Solicitação de Aprovação',
  modalTamanho: 'xl',
  modalCorHeader: 'var(--bs-info)',

  confirmacaoReprovarTitulo: 'Reprovar',
  confirmacaoReprovarMensagem: 'Tem certeza que deseja <strong>reprovar</strong> esta solicitação?<br><br><textarea id="observacaoReprovacao" class="form-control" rows="3" placeholder="Observação (opcional)..." style="text-align: left; font-size: 0.9rem;"></textarea>',
  confirmacaoAprovarTitulo: 'Aprovar',
  confirmacaoAprovarMensagem: 'Tem certeza que deseja <strong>aprovar</strong> esta solicitação?<br><br><textarea id="observacaoAprovacao" class="form-control" rows="3" placeholder="Observação (opcional)..." style="text-align: left; font-size: 0.9rem;"></textarea>',

  emptyMessage: 'Nenhuma solicitação de aprovação de Purchase Order pendente encontrada.',
  hintMessage: 'Duplo clique na linha para analisar a solicitação',

  filtrosPadrao: {
    buscaNumero: '',
    buscaResumo: '',
    idGrupoAprovador: null,
    faixaValor: ''
  }
}

registrarFuncao('PurchaseOrder', definicao)

export default definicao
